import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Api from "../../../lib/componentApi";
import Loading from "../../../components/Common/Loading";
import customUrlSearchParams from "../../../lib/customUrlSearchParams";
import serialize from "serialize-javascript";

class ThreeDCheckout extends Component {
  constructor(props) {
    super(props);
    const searchParams = new customUrlSearchParams(props.location.search);
    this.state = {
      paymentIntent: searchParams.get("payment_intent"),
      paymentIntentClientSecret: searchParams.get(
        "payment_intent_client_secret"
      ),
      sourceType: searchParams.get("source_type"),
      loading: true,
      orderSubmitted: null,
      message: null,
      title: null,
      code: null
    };
  }
  componentDidMount() {
    const { paymentIntent, paymentIntentClientSecret, sourceType } =
      this.state || "";
    Api.post(
      "/api/3d/secure/checkout",
      { paymentIntent, paymentIntentClientSecret, sourceType },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          //FOR ANDROID
          if (window.LocaleWebInterface) {
            const serialized = serialize(response);
            window.LocaleWebInterface.paymentResult(serialized);
          }

          //FOR IOS
          if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.send3DSecureResult
          ) {
            window.webkit.messageHandlers.send3DSecureResult.postMessage(
              JSON.stringify(response)
            );
          }
          this.setState({
            orderSubmitted: true,
            message: response.message,
            title: response.title,
            code: response.code,
            loading: false
          });
        } else {
          console.log("static!");
        }
        this.setState({ loading: false });
      }
    );
  }
  handleClickClose = () => {
    const { code } = this.state;
    let link;
    if (code) {
      if (code === 2101) {
        link = "/";
      } else {
        link = "/checkout";
      }
    }
    if (link) {
      window.location.href = link;
    }
  };
  render() {
    const { message, title, loading } = this.state;
    return (
      (!loading && (
        <React.Fragment>
          <div>
            <div className="modal-bg" />
            {/* Header */}
            <div className="head-general with-back">
              <a
                href="javascript: void(0)"
                className="back"
                onClick={this.handleClickClose}
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>{title}</h4>
              <a href="javascript: void(0)" className="close" />
            </div>
            {/* Header */}
            <div className="modal">
              <div className="modal-body">
                <div>
                  <div className="white-bg mt-10px alert-box">{message}</div>
                  <div className="use-buttons">
                    <button
                      className="btn btn-blue"
                      onClick={this.handleClickClose}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )) || <Loading />
    );
  }
}

export default withRouter(ThreeDCheckout);
